import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Seo from "../components/common/seo";

import INFO from "../data/user";
import myArticles from "../data/articles";

import "./styles/readArticle.css";

let ArticleStyle = styled.div``;

const ReadArticle = () => {
	const navigate = useNavigate();
	let { slug } = useParams();

	const article = myArticles[slug - 1];

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [article]);

	if (!article) {
		return (
			<React.Fragment>
				<Seo
					title={`Article Not Found | ${INFO.main.title}`}
					description="The requested article was not found."
					path={`/article/${slug}`}
					noindex
				/>

				<div className="page-content">
					<NavBar />
					<div className="content-wrapper">
						<div className="read-article-logo-container">
							<div className="read-article-logo">
								<Logo width={46} />
							</div>
						</div>

						<div className="read-article-container">
							<div className="read-article-wrapper">
								<h1 className="title read-article-title">
									Article not found
								</h1>
							</div>
						</div>
						<div className="page-footer">
							<Footer />
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}

	const articleData = article();

	ArticleStyle = styled.div`
		${articleData.style}
	`;

	return (
		<React.Fragment>
			<Seo
				title={`${articleData.title} | ${INFO.main.title}`}
				description={articleData.description}
				keywords={articleData.keywords}
				path={`/article/${slug}`}
				type="article"
			/>

			<div className="page-content">
				<NavBar />

				<div className="content-wrapper">
					<div className="read-article-logo-container">
						<div className="read-article-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="read-article-container">
						<div className="read-article-back">
							<img
								src="../back-button.png"
								alt="back"
								className="read-article-back-button"
								onClick={() => navigate(-1)}
								width="24"
								height="24"
								decoding="async"
							/>
						</div>

						<div className="read-article-wrapper">
							<div className="read-article-date-container">
								<div className="read-article-date">
									{articleData.date}
								</div>
							</div>

							<h1 className="title read-article-title">
								{articleData.title}
							</h1>

							<div className="read-article-body">
								<ArticleStyle>{articleData.body}</ArticleStyle>
							</div>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ReadArticle;
